import { useContext, useState } from "react";
import ReactVisibilitySensor from "react-visibility-sensor";
import { LangContext } from "../../../App";
import useWindowSize from "../../../hooks/useWindowSize";

const MainHeroSection = ({
  videos,
  image,
  title,
  subtitle,
  posterImage
}: {
  videos: string[];
  image: string;
  title: string;
  subtitle: string;
  posterImage? : string;
}) => {
  const width = useWindowSize();
  const { lang } = useContext(LangContext);
  const [overlayActive, setOverlayActive] = useState<boolean>(false);

  return (
    <header className={`hero-section ${lang === 0 ? "" : "rtl"}`} id="header">
      <img src={image} className="background-image" alt={"Hero background"} />
      <div className="videos-container">
        <ReactVisibilitySensor partialVisibility>
          {({ isVisible }: any) => (
            <div
              className={`left-arrow an-rotate-left-fade-in ${
                isVisible ? "an-active" : ""
              }`}
            >
              <div className="overlay"></div>
              <video
                aria-disabled
                aria-hidden="true"
                tabIndex={-1}
                className="hero-video"
                src={videos[0]}
                autoPlay={true}
                width={225}
                height={450}
                loop
                muted
                controls={false}
                playsInline
                webkit-playsinline
                preload="true"
                id="hero-vido-1"
                poster={posterImage}
                hidden={width < 900}
                aria-label="Meaningless video"
              ></video>
            </div>
          )}
        </ReactVisibilitySensor>
        <div className="middle-body">
          <ReactVisibilitySensor partialVisibility>
            {({ isVisible }: any) => (
              <div
                className={`top-arrow an-rotate-top-fade-in ${
                  isVisible ? "an-active" : ""
                }`}
                //   onMouseOver={() => handleStartVideo(2)}
              >
                <div className="overlay"></div>
                <video
                  aria-disabled
                  aria-hidden="true"
                  tabIndex={-1}
                  className="hero-video"
                  src={videos[2]}
                  autoPlay={true}
                  width={450}
                  height={225}
                  loop
                  muted
                  controls={false}
                  playsInline
                  webkit-playsinline
                  preload="true"
                  id="hero-vido-2"
                  poster={posterImage}
                  hidden={width < 900}
                  aria-label="Meaningless video"
                />
              </div>
            )}
          </ReactVisibilitySensor>
          <ReactVisibilitySensor partialVisibility>
            {({ isVisible }: any) => (
              <div
                className={`bottom-arrow an-rotate-bottom-fade-in ${
                  isVisible ? "an-active" : ""
                }`}
                //   onMouseOver={() => handleStartVideo(3)}
              >
                <div className="overlay"></div>
                <video
                  aria-disabled
                  aria-hidden="true"
                  tabIndex={-1}
                  id="hero-vido-3"
                  className="hero-video"
                  src={videos[1]}
                  width={450}
                  height={255}
                  loop
                  autoPlay
                  muted
                  controls={false}
                  title="Meaningless video"
                  translate="no"
                  playsInline
                  webkit-playsinline
                  preload="true"
                  poster={posterImage}
                  hidden={width < 900}
                  aria-label="Meaningless video"
                />
              </div>
            )}
          </ReactVisibilitySensor>
        </div>
        <ReactVisibilitySensor partialVisibility>
          {({ isVisible }: any) => (
            <div
              className={`right-arrow an-rotate-right-fade-in ${
                isVisible ? "an-active" : ""
              }`}
              // onMouseOver={() => handleStartVideo(4)}
            >
              <div id="overlay-4" className={`overlay ${overlayActive && lang ? "active" : ""}`}></div>
              <video
                aria-disabled
                aria-hidden="true"
                id="hero-vido-4"
                className="hero-video"
                src={videos[3]}
                width={225}
                height={450}
                tabIndex={-1}
                loop
                autoPlay
                muted
                controls={false}
                title="Meaningless video"
                translate="no"
                playsInline
                webkit-playsinline
                preload="true"
                poster={posterImage}
                hidden={width < 900}
                aria-label="Meaningless video"
                // poster={}
              />
            </div>
          )}
        </ReactVisibilitySensor>
      </div>
      <div className="top-layer">
        <div 
          className="layer-wrapper" 
          onMouseEnter={() =>  {
            setOverlayActive(true);
          }}
          onMouseLeave={() =>  {
            setOverlayActive(false);
          }}
        >
          <ReactVisibilitySensor partialVisibility>
            {({ isVisible }: any) => (
              <h1
                className={`title an-move-left-fade-in ${
                  isVisible ? "an-active" : ""
                }`}
              >
                {title}
              </h1>
            )}
          </ReactVisibilitySensor>
          <ReactVisibilitySensor partialVisibility>
            {({ isVisible }: any) => (
              <p
                className={`subtitle an-move-left-fade-in an-d-2 ${
                  isVisible ? "an-active" : ""
                }`}
              >
                {subtitle}
              </p>
            )}
          </ReactVisibilitySensor>
        </div>
      </div>
    </header>
  );
};

export default MainHeroSection;
